import CountdownTimer from "components/hero/countdown"
import styled from "styled-components"
import minWidth from "utils/minWidth"

export const CountdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  min-height: 75rem;
  justify-content: center;

  p {
    margin: 0.5rem 2rem;
    font-size: 1.2rem;

    ${minWidth.tablet`
      font-size: 2rem;
      margin-left:0;
    `}
  }

  > * {
    margin-bottom: 2rem; /* Adjust the margin value as needed */
  }
`

export const Countdown = styled(CountdownTimer)`
  text-align: center;

  div {
    font-size: 4rem;
  }

  h6 {
    font-size: 4rem;
  }
`
